import { HTTPStatusCode } from "@libs/api/types";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const FplConstantsApi = {
  getFplConstantsByYear: async (year: number) => {
    const res = await tsRestClient().fplConstants.getFplConstantsByYear({
      params: { year },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in FplConstantsApi.getFplConstantsByYear",
      error: res.body,
      shouldThrowError: true,
    });
  },
};
